/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_A7Inputs */

const en_cad_faq_a7 = /** @type {(inputs: Cad_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft AI (cadcraft.org) is an independent guide to CADCraft: download and installation instructions, an online version, tutorials and a comparison with Autodesk AutoCAD. Downloads link to the official GitHub releases. Contact us at support@cadcraft.org.`)
};

/**
* | output |
* | --- |
* | "CADCraft AI (cadcraft.org) is an independent guide to CADCraft: download and installation instructions, an online version, tutorials and a comparison with Au..." |
*
* @param {Cad_Faq_A7Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_a7 = /** @type {((inputs?: Cad_Faq_A7Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_A7Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_a7(inputs)
});
export { cad_faq_a7 as "cad.faq.a7" }